import { useRecordContext } from 'ra-core';
import { ListButton } from 'react-admin';

export const LinkToWallet = () => {
  const record = useRecordContext();
  const { id } = record;
  return <ListButton to={`/subscriptions/${id}/show`} label={'Wallet'} />;
};
